import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGenericResponse } from '../interfaces/reponse.interface';
import * as Util from '../helpers/utils';
import { Observable } from 'rxjs';
import { ICredentials } from '../interfaces/auth.interface';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpClient
  ) { }
  
  login (data: ICredentials): Observable<IGenericResponse>{
    const url: string = `${Util.getUrl('/session')}/login`;
    return this.http.post<IGenericResponse>(url, data);
  }

  refresh(token: string): Observable<IGenericResponse>{
    const url: string = `${Util.getUrl('/session')}/refresh`;
    return this.http.post<IGenericResponse>(url, { token });
  }

  getProfile(): Observable<IGenericResponse>{
    const url: string = `${Util.getUrl('/session')}/profile`;
    return this.http.get<IGenericResponse>(url);
  }

  getProfileById(userId: string): Observable<IGenericResponse>{
    const url: string = `${Util.getUrl('/session')}/profile?uid=${userId}`;
    return this.http.get<IGenericResponse>(url);
  }

  saveProfile(data:any): Observable<IGenericResponse>{
    const url: string = `${Util.getUrl('/session')}/saveprofile`;
    return this.http.post<IGenericResponse>(url, { data });
  }

  getUsersList(): Observable<IGenericResponse>
  {
    const url: string = `${Util.getUrl('/session')}/list`;
    return this.http.get<IGenericResponse>(url);
  }

  getPermissions(type: string, uid: string): Observable<IGenericResponse>
  {
    const url: string = `${Util.getUrl('/permissions')}/list/${type}/${uid}`;
    return this.http.get<IGenericResponse>(url);
  }

  savePermission(data: any): Observable<IGenericResponse>
  {
    const url: string = `${Util.getUrl('/permissions')}/save`;
    return this.http.post<IGenericResponse>(url, data);
  }
}
